import type { FormGroup } from '../types/trigger';

export const FIELDS_GROUP_ID = 1;
export const FILTERS_GROUP_ID = 2;
export const DEFAULT_INPUTS_ID = 3;
export const FILTERS_GROUP_NAME = 'filters';

export const defaultFormGroups = (): FormGroup[] => {
    return [
        { groupId: FIELDS_GROUP_ID, groupName: 'fields' },
        { groupId: FILTERS_GROUP_ID, groupName: FILTERS_GROUP_NAME },
        { groupId: DEFAULT_INPUTS_ID, groupName: 'default-inputs' }
    ];
};

